<template>

  <div class="container pt-4 mb-5">

    <div>

      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">

              <label>
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Opisz grupę docelową dla której ma powstać aplikacja:
              </label>

              <b-input-group>

                <b-form-input v-model="targetGroup" size="lg" ref="targetGroup" placeholder="np. młodzi przedsiębiorcy zainteresowani technologią"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">

              <label>
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Wybierz twórcę startupów:
              </label>

              <b-input-group>

                <b-form-select v-model="mentor" ref="mentor" size="lg" :options="mentors"></b-form-select>

              </b-input-group>

            </div>
 
          </div>

        </b-col>

      </b-row>

      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">

        </b-col>

        <b-col lg="6">

          <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
            Poproś o poradę
          </b-button>

        </b-col>

      </b-row>



      <div class="mt-2" >

        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje poradę <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Porada</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">

            <div v-html="result" class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;"></div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>

        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>

    </div>

  </div>

</template>

<script>
import { languages } from './../../../resources/languages.js';


export default {
  name: 'AppBussinesMentorAi',
  components: {
  },
  data() {
    return {
      isFinish: false,
      result: "",
      selectedText: '',
      query: "",
      lang: "Polski",
      languages,
      question: "",
      mentors: [
        "Elon Musk – Tesla, SpaceX, X (Twitter), Neuralink",
        "Steve Jobs – Apple",
        "Jeff Bezos – Amazon",
        "Mark Zuckerberg – Meta (Facebook, Instagram)",
        "Sam Altman – OpenAI",
        "Paul Graham – Y Combinator",
        "Reid Hoffman – LinkedIn",
        "Marc Andreessen – Andreessen Horowitz",
        "Ben Horowitz – Andreessen Horowitz",
        "Peter Thiel – PayPal, Founders Fund",
        "Brian Chesky – Airbnb",
        "Drew Houston – Dropbox",
        "Tobi Lütke – Shopify",
        "Patrick Collison – Stripe",
        "John Collison – Stripe",
        "Des Traynor – Intercom",
        "Stewart Butterfield – Slack",
        "Melanie Perkins – Canva",
        "Kevin Systrom – Instagram",
        "Jan Koum – WhatsApp",
        "Sean Ellis – GrowthHackers",
        "Ryan Hoover – Product Hunt",
        "Alex Hormozi – Acquisition.com",
        "Chamath Palihapitiya – Social Capital",
        "Naval Ravikant – AngelList",
        "Jason Fried – Basecamp",
        "Pieter Levels – Nomad List, Remote OK",
        "Sahil Lavingia – Gumroad",
        "Courtland Allen – Indie Hackers",
        "Andrew Wilkinson – Tiny",
        "Larry Page – Google (Alphabet)",
        "Sergey Brin – Google (Alphabet)",
        "Demis Hassabis – DeepMind",
        "Jensen Huang – NVIDIA",
        "Ilya Sutskever – OpenAI",
        "Andrej Karpathy – Tesla, OpenAI",
        "Emad Mostaque – Stability AI",
        "Mustafa Suleyman – Inflection AI",
        "Noam Shazeer – Character.ai",
        "Vitalik Buterin – Ethereum",
        "Ray Dalio – Bridgewater Associates",
        "Charlie Munger – Berkshire Hathaway",
        "Nassim Taleb – Autor / myśliciel",
        "Tim Ferriss – Autor, inwestor",
        "Balaji Srinivasan – Ex-CTO Coinbase",
        "Evan Spiegel – Snap Inc.",
        "Daniel Ek – Spotify",
        "Jack Dorsey – Twitter (X), Block",
        "Guillermo Rauch – Vercel",
        "Balaji Srinivasan – Autor Network State"
      ],
      mentor: "",
      finishContent: '',
      selectedSchema: null
    }
  },
  methods: {

    generateFinish: function() {

      if(!this.mentor) return false;
      if(!this.targetGroup) return false;


      this.$refs.generatePost.disabled = true

      this.isFinish = true

      this.finishContent = ""
      this.result = ""

      var query = "";

      query = "Wciel się w sposób myślenia twórcy StartUp " + this.mentor + " i wymyśl mi 30 pomysłów na aplikację na telefon, która rozwiązuje konkretny problem grupy docelowej " + this.targetGroup + ". Myśl jak " + this.mentor + ".";
   
      var doneText = "";

      this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {

        let data = response.data

        if(data.redirectTo) {

          top.location.href = data.redirectTo;

        }

        doneText = data.result;

        this.finishContent = doneText;

        this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

        this.$refs.generatePost.disabled = false
        this.generatedPostTitle = "Wygenerowany artykuł"

      }).catch(function() {

        this.$refs.generatePost.disabled = false

      })



    },

    copyResults: function() {

      this.$refs.finishContent.style.display = "block";

      this.$refs.finishContent.focus();

      document.execCommand('copy');

      this.$refs.finishContent.style.display = "none"

      window.scrollTo(0, 0)

      this.$bvToast.toast('Treść została skopiowana do schowka', {
        title: 'Skopiowano',
        autoHideDelay: 5000,
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
        noCloseButton: true
      })

    }

  },
  computed: {

  },
  created() {

    this.$watch('finishContent', (value) => {

      var lines = value.split(/\r|\r\n|\n/);

      this.finishLinesCount = lines.length;

    })

  },
  mounted() {

    if (localStorage.generators_language) {

      this.lang = localStorage.generators_language;

    } else {

      localStorage.generators_language = "Polski"
      this.lang = "Polski"
    }

  },
  watch: {

    lang(data) {

      localStorage.generators_language = data;

    }

  }

}
</script>

<style>

.pointer { cursor: pointer; }
.bold { font-weight: 600 !important; }
code { color: #4e82f7 !important; }
</style>
